import { render, staticRenderFns } from "./NewIntegrationModal.vue?vue&type=template&id=70e0cafb"
import script from "./NewIntegrationModal.vue?vue&type=script&lang=js"
export * from "./NewIntegrationModal.vue?vue&type=script&lang=js"
import style0 from "./NewIntegrationModal.vue?vue&type=style&index=0&id=70e0cafb&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports